import { initialState } from "./state"


export const setCampaign = (state, payload) => {
  state.campaign = payload
}

export const setCampaigns = (state, payload) => {
  state.campaigns = payload
}

export const setTargets = (state, payload) => {
  state.targets = payload
}

export const setTargetDetail = (state, payload) => {
  state.targetDetail = payload
}

export const setRuleChains = (state, payload) => {
  state.ruleChains = payload
}

export const reset = (state) => {
  const s = initialState()

  Object.keys(s).forEach((key) => {
    state[key] = s[key]
  })
}
